import { AxiosRequestConfig } from 'axios';
import { _logOut, refreshToken } from 'src/services/redux/slices/auth/auth-slice';

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  skipToken?: boolean;
}

export const REFRESH_URL = `${process.env.REACT_APP_API_AUTH_URL}/api/auth/refresh`;
// const PLATFORM = `${process.env.REACT_APP_PLATFORM}`;

const saveRemainingTime = (expireTime: number) => {
  localStorage.setItem('refreshExpireTime', expireTime.toString());
};

// Sayfa yenilendiğinde kalan süreyi yükleyebileceğimiz bir fonksiyon
const getRemainingTime = () => {
  const savedExpireTime = localStorage.getItem('refreshExpireTime');
  if (savedExpireTime) {
    const expireTime = parseInt(savedExpireTime, 10);
    const remainingTime = expireTime - Date.now();
    return remainingTime > 0 ? remainingTime : 0;
  } else {
    const expireTime = Date.now() + 15 * 60 * 1000; // 15 dakika
    saveRemainingTime(expireTime);
  }
  return 15 * 60 * 1000; // Eğer bir değer yoksa 1 dakika varsayılan
};

export default function setupAxios(axios: any, store: any) {
  let isRefreshing = false;
  axios.interceptors.request.use(
    async (config: CustomAxiosRequestConfig) => {
      const {
        auth: { token, refreshToken: authRefreshToken },
      } = store.getState();
      if (!config.headers) {
        config.headers = {};
      }
      if (token && !config.skipToken) {
        config.headers.Token = token;
        const remainingTime = getRemainingTime();

        if (remainingTime <= 0 && authRefreshToken) {
          const expireTime = Date.now() + 15 * 60 * 1000;

          if (!isRefreshing && authRefreshToken) {
            isRefreshing = true;

            const response = await store.dispatch(refreshToken());
            if (response.type === 'auth/refreshToken/rejected') {
              await store.dispatch(_logOut());
            } else {
              isRefreshing = true;
            }
            saveRemainingTime(expireTime);
            isRefreshing = false;
          }
        }
      }

      return config;
    },
    (err: any) => Promise.reject(err),
  );
  axios.interceptors.response.use(
    (response: any) => {
      return response;
    },
    async (error: any) => {
      const config = error?.config;
      // const {
      //   auth: { refreshToken },
      // } = store.getState();

      if (error?.response?.status === 401 && !config?.sent) {
        config.sent = true;

        await store.dispatch(_logOut());
        // window.location?.reload();

        return axios(config);
      }
      return Promise.reject(error);
    },
  );
}
